import Keycloak from "keycloak-js";
import Vue from "vue";

let keycloak = null;
let watch = {};

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */

function updateWatchVariables(isAuthenticated = false) {
  watch.authenticated = isAuthenticated;
  watch.loginFn = keycloak?.login;
  watch.login = keycloak?.login;
  watch.createLoginUrl = keycloak?.createLoginUrl;
  watch.createLogoutUrl = keycloak?.createLogoutUrl;
  watch.createRegisterUrl = keycloak?.createRegisterUrl;
  watch.register = keycloak?.register;
  if (isAuthenticated) {
    watch.accountManagement = keycloak?.accountManagement;
    watch.createAccountUrl = keycloak?.createAccountUrl;
    watch.hasRealmRole = keycloak?.hasRealmRole;
    watch.hasResourceRole = keycloak?.hasResourceRole;
    watch.loadUserProfile = keycloak?.loadUserProfile;
    watch.loadUserInfo = keycloak?.loadUserInfo;
    watch.updateToken = keycloak?.updateToken;
    watch.token = keycloak?.token;
    watch.subject = keycloak?.subject;
    watch.idToken = keycloak?.idToken;
    watch.idTokenParsed = keycloak?.idTokenParsed;
    watch.realmAccess = keycloak?.realmAccess;
    watch.resourceAccess = keycloak?.resourceAccess;
    watch.refreshToken = keycloak?.refreshToken;
    watch.refreshTokenParsed = keycloak?.refreshTokenParsed;
    watch.timeSkew = keycloak?.timeSkew;
    watch.responseMode = keycloak?.responseMode;
    watch.responseType = keycloak?.responseType;
    watch.tokenParsed = keycloak?.tokenParsed;
    watch.userName = keycloak?.tokenParsed?.["preferred_username"];
    watch.fullName = keycloak?.tokenParsed?.["name"];
  }
}
const Login = (onAuthenticatedCallback) => {
  if (keycloak) {
    keycloak.onReady = function (authenticated) {
      console.log("keycloak.onReady", authenticated);
    };

    keycloak.onAuthSuccess = function () {
      updateWatchVariables(true);
      // Check token validity every 10 seconds (10 000 ms) and, if necessary, update the token.
      // Refresh token if it's valid for less then 60 seconds
      const updateTokenInterval = setInterval(() => {
        if (keycloak) {
          keycloak
            .updateToken(60)
            .then((refreshed) => {
              if (refreshed) {
                console.log("Token refreshed" + refreshed);
              }
            })
            .catch(() => {
              keycloak?.clearToken();
            });
        }
      }, 10000);
      watch.logoutFn = () => {
        clearInterval(updateTokenInterval);
        keycloak.logout({});
      };
    };
    keycloak.onAuthRefreshSuccess = function () {
      updateWatchVariables(true);
    };

    keycloak.onAuthRefreshError = () => {
      console.log("onAuthRefreshError");
    };

    keycloak
      .init({
        onLoad: "login-required",
        silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
        checkLoginIframe: false,
        pkceMethod: "S256",
        enableLogging: true,
      })
      .then(function (authenticated) {
        Object.defineProperty(Vue.prototype, "$keycloak", {
          get() {
            return watch;
          },
        });
        authenticated ? onAuthenticatedCallback() : alert("non authenticated");
      })
      .catch((e) => {
        console.log(`keycloak init exception: ${e}`);
      });
  }
};

const initKeycloakConfig = (config) => {
  keycloak = new Keycloak(config);
};

export default {
  CallLogin: Login,
  InitKeycloakConfig: initKeycloakConfig,
};
